<template>
  <div>
    <a-card class="c_annualPlafon">
      <div slot="title" class="m-display-flex space-between custom">
        <span class="cmain-title"
          ><a-icon type="project" />&nbsp;Cashflow Planning</span
        >
        <a-button
          type="primary"
          class="cbtn-create"
          icon="plus"
          @click="showModal('Create')"
          >Create</a-button
        >
      </div>

      <a-row :gutter="8">
        <a-col :span="24" class="margin-bottom">
          <a-card class="filter=card">
            <div :class="getScreen ? 'm-width-full' : 'm-display-flex'">
              <div :style="getScreen ? 'width:100%' : ''">
                &nbsp;Tahun :&nbsp;<a-select
                  placeholder="Choose"
                  v-model="selected.year"
                  @change="changeYear"
                  :filterOption="filterOption"
                  showSearch
                  :style="getScreen ? '' : 'width:200px'"
                  :class="getScreen ? 'm-width-full' : ''"
                  :disabled="loading.page"
                >
                  <a-select-option
                    v-for="item in year"
                    :key="item"
                    :value="item"
                    >{{ item }}</a-select-option
                  >
                </a-select>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :span="24">
          <a-card class="custom-card">
            <a-table
              size="small"
              rowKey="key"
              :columns="columns"
              :data-source="data_table"
              :loading="loading.table"
              :pagination="false"
              class="custom-table"
              bordered
              :scroll="{ x: 2000 }"
            >
              <template slot="pendapatan" slot-scope="text, item, index">
                {{ customFormatCurrency("IDR", item.pendapatan) }}
              </template>
              <template
                slot="pengeluaran_beban_proyek"
                slot-scope="text, item, index"
              >
                {{ customFormatCurrency("IDR", item.pengeluaran_beban_proyek) }}
              </template>
              <template
                slot="pengeluaran_pengadaan_inventori"
                slot-scope="text, item, index"
              >
                {{
                  customFormatCurrency(
                    "IDR",
                    item.pengeluaran_pengadaan_inventori
                  )
                }}
              </template>
              <template
                slot="pengeluaran_beban_admin_umum"
                slot-scope="text, item, index"
              >
                {{
                  customFormatCurrency("IDR", item.pengeluaran_beban_admin_umum)
                }}
              </template>
              <template
                slot="pengeluaran_beban_penjualan"
                slot-scope="text, item, index"
              >
                {{
                  customFormatCurrency("IDR", item.pengeluaran_beban_penjualan)
                }}
              </template>
              <template
                slot="pengeluaran_investasi_pengadaan_aset"
                slot-scope="text, item, index"
              >
                {{
                  customFormatCurrency(
                    "IDR",
                    item.pengeluaran_investasi_pengadaan_aset
                  )
                }}
              </template>
              <template
                slot="pengeluaran_investasi_pengembangan_produk"
                slot-scope="text, item, index"
              >
                {{
                  customFormatCurrency(
                    "IDR",
                    item.pengeluaran_investasi_pengembangan_produk
                  )
                }}
              </template>
              <template
                slot="pengeluaran_investasi_pengembangan_pasar"
                slot-scope="text, item, index"
              >
                {{
                  customFormatCurrency(
                    "IDR",
                    item.pengeluaran_investasi_pengembangan_pasar
                  )
                }}
              </template>
              <template
                slot="pengeluaran_kewajiban_hutang_cop"
                slot-scope="text, item, index"
              >
                {{
                  customFormatCurrency(
                    "IDR",
                    item.pengeluaran_kewajiban_hutang_cop
                  )
                }}
              </template>
              <template
                slot="pengeluaran_investasi_pengembangan_teknologi"
                slot-scope="text, item, index"
              >
                {{
                  customFormatCurrency(
                    "IDR",
                    item.pengeluaran_investasi_pengembangan_teknologi
                  )
                }}
              </template>
              <template
                slot="pengeluaran_investasi_pembangunan_aset_tetap"
                slot-scope="text, item, index"
              >
                {{
                  customFormatCurrency(
                    "IDR",
                    item.pengeluaran_investasi_pembangunan_aset_tetap
                  )
                }}
              </template>
              <template slot="total_pengeluaran" slot-scope="text, item, index">
                {{ customFormatCurrency("IDR", item.total_pengeluaran) }}
              </template>
              <template slot="pendanaan" slot-scope="text, item, index">
                {{ customFormatCurrency("IDR", item.pendanaan) }}
              </template>
              <template slot="bunga_bank" slot-scope="text, item, index">
                {{ customFormatCurrency("IDR", item.bunga_bank) }}
              </template>
              <template slot="create_by" slot-scope="text, item, index">
                {{ item.create_dt + " / " + item.tlc_create }}
              </template>
              <template slot="update_by" slot-scope="text, item, index">
                {{
                  item.update_dt ? item.update_dt + " / " + item.tlc_update : ""
                }}
              </template>
              <span slot="action" slot-scope="item">
                <a-button
                  type="primary"
                  :key="item.id_fc_cashflow_planning"
                  @click="showModal('Edit', item)"
                >
                  Edit
                </a-button>
              </span>
            </a-table>
          </a-card>
        </a-col>
      </a-row>
    </a-card>

    <a-modal
      :visible="show_modal"
      @cancel="modalOnClose"
      :footer="null"
      :maskClosable="false"
      width="50%"
    >
      <span slot="title">
        <a-icon :type="type_modal" /> {{ mode_modal }} Cashflow Planning</span
      >
      <a-form :form="form_create">
        <a-row :gutter="8">
          <a-col :span="12"
            ><a-form-item label="Tahun">
              <a-date-picker
                v-decorator="[
                  'year',
                  { rules: [{ required: true }], initialValue: moment() },
                ]"
                mode="year"
                format="YYYY"
                placeholder="Select year"
                :open="yearOpen"
                @panelChange="handleYearChange"
                @openChange="handleOpenChange"
                :disabled="mode_modal == 'Edit' ? true : false"
              /> </a-form-item
          ></a-col>
          <a-col :span="12"
            ><a-form-item label="Pendapatan">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pendapatan',
                  {
                    rules: [
                      { required: true, message: 'Pendapatan wajib diisi' },
                    ],
                    initialValue: form.pendapatan,
                  },
                ]"
              /> </a-form-item></a-col
        ></a-row>
        <a-divider orientation="left">
          Pengeluaran
        </a-divider>
        <a-row :gutter="8">
          <a-col :span="12">
            <a-form-item label="Beban Proyek">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_beban_proyek',
                  {
                    rules: [
                      { required: true, message: 'Beban Proyek wajib diisi' },
                    ],
                    initialValue: form.pengeluaran_beban_proyek,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
            <a-form-item label="Pengadaan Inventori">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_pengadaan_inventori',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Pengadaan Inventori wajib diisi',
                      },
                    ],
                    initialValue: form.pengeluaran_pengadaan_inventori,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
            <a-form-item label="Beban Admin-Umum">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_beban_admin_umum',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Beban Admin-Umum wajib diisi',
                      },
                    ],
                    initialValue: form.pengeluaran_beban_admin_umum,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
            <a-form-item label="Beban Penjualan">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_beban_penjualan',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Beban Penjualan wajib diisi',
                      },
                    ],
                    initialValue: form.pengeluaran_beban_penjualan,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
            <a-form-item label="Investasi Pengadaan Aset">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_investasi_pengadaan_aset',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Investasi Pengadaan Aset wajib diisi',
                      },
                    ],
                    initialValue: form.pengeluaran_investasi_pengadaan_aset,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="Investasi Pengembangan Produk">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_investasi_pengembangan_produk',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Investasi Pengembangan Produk wajib diisi',
                      },
                    ],
                    initialValue:
                      form.pengeluaran_investasi_pengembangan_produk,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
            <a-form-item label="Investasi Pengembangan Pasar">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_investasi_pengembangan_pasar',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Investasi Pengembangan Pasar wajib diisi',
                      },
                    ],
                    initialValue: form.pengeluaran_investasi_pengembangan_pasar,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
            <a-form-item label="Kewajiban Hutang + cop">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_kewajiban_hutang_cop',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Kewajiban Hutang + cop wajib diisi',
                      },
                    ],
                    initialValue: form.pengeluaran_kewajiban_hutang_cop,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
            <a-form-item label="Investasi Pengembangan Teknologi">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_investasi_pengembangan_teknologi',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Investasi Pengembangan Teknologi wajib diisi',
                      },
                    ],
                    initialValue:
                      form.pengeluaran_investasi_pengembangan_teknologi,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
            <a-form-item label="Investasi Pembangunan Aset Tetap">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pengeluaran_investasi_pembangunan_aset_tetap',
                  {
                    rules: [
                      {
                        required: true,
                        message: 'Investasi Pembangunan Aset Tetap wajib diisi',
                      },
                    ],
                    initialValue:
                      form.pengeluaran_investasi_pembangunan_aset_tetap,
                  },
                ]"
                @keyup="handleKeyup"
              />
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider orientation="right">
          Total Pengeluaran : {{ customFormatCurrency("IDR", sum_pengeluaran) }}
        </a-divider>
        <a-row :gutter="8">
          <a-col :span="12"
            ><a-form-item label="Pendanaan">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'pendanaan',
                  {
                    rules: [
                      { required: true, message: 'Pendanaan wajib diisi' },
                    ],
                    initialValue: form.pendanaan,
                  },
                ]"
              /> </a-form-item
          ></a-col>
          <a-col :span="12"
            ><a-form-item label="Bunga Bank">
              <a-input-number
                type="number"
                class="m-width-full m-text-align-right"
                v-on:keydown.enter.prevent="preventEnterButton"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
                v-decorator="[
                  'bunga_bank',
                  {
                    rules: [
                      { required: true, message: 'Bunga Bank wajib diisi' },
                    ],
                    initialValue: form.bunga_bank,
                  },
                ]"
              /> </a-form-item></a-col
        ></a-row>
        <div class="footer-card">
          <a-button type="secondary" html-type="submit" @click="modalOnClose"
            >Cancel</a-button
          >
          <a-button
            :loading="loading.submit"
            type="primary"
            html-type="submit"
            @click="onSubmit"
            ><b>Submit</b></a-button
          >
        </div>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import _ from "lodash";

export default {
  mixins: [CurrencyFormat],
  data() {
    const columns = [
      {
        title: "Tahun",
        key: "year",
        width: 75,
        align: "center",
        dataIndex: "year",
      },
      {
        title: "Pendapatan",
        key: "pendapatan",
        // width: 150,
        align: "right",
        scopedSlots: { customRender: "pendapatan" },
      },
      {
        title: "Pengeluaran",
        children: [
          {
            title: "Beban Proyek",
            key: "pengeluaran_beban_proyek",
            // width: 150,
            align: "right",
            scopedSlots: { customRender: "pengeluaran_beban_proyek" },
          },
          {
            title: "Pengadaan Inventori",
            key: "pengeluaran_pengadaan_inventori",
            // width: 150,
            align: "right",
            scopedSlots: { customRender: "pengeluaran_pengadaan_inventori" },
          },
          {
            title: "Beban Admin Umum",
            key: "pengeluaran_beban_admin_umum",
            // width: 150,
            align: "right",
            scopedSlots: { customRender: "pengeluaran_beban_admin_umum" },
          },
          {
            title: "Beban Penjualan",
            key: "pengeluaran_beban_penjualan",
            // width: 150,
            align: "right",
            scopedSlots: { customRender: "pengeluaran_beban_penjualan" },
          },
          {
            title: "Investasi Pengadaan Aset",
            key: "pengeluaran_investasi_pengadaan_aset",
            // width: 150,
            align: "right",
            scopedSlots: {
              customRender: "pengeluaran_investasi_pengadaan_aset",
            },
          },
          {
            title: "Investasi Pengembangan Produk",
            key: "pengeluaran_investasi_pengembangan_produk",
            // width: 150,
            align: "right",
            scopedSlots: {
              customRender: "pengeluaran_investasi_pengembangan_produk",
            },
          },
          {
            title: "Investasi Pengembangan Pasar",
            key: "pengeluaran_investasi_pengembangan_pasar",
            // width: 150,
            align: "right",
            scopedSlots: {
              customRender: "pengeluaran_investasi_pengembangan_pasar",
            },
          },
          {
            title: "Kewajiban Hutang Cop",
            key: "pengeluaran_kewajiban_hutang_cop",
            // width: 150,
            align: "right",
            scopedSlots: { customRender: "pengeluaran_kewajiban_hutang_cop" },
          },
          {
            title: "Investasi Pengembangan Teknologi",
            key: "pengeluaran_investasi_pengembangan_teknologi",
            // width: 150,
            align: "right",
            scopedSlots: {
              customRender: "pengeluaran_investasi_pengembangan_teknologi",
            },
          },
          {
            title: "Investasi Pembangunan Aset Tetap",
            key: "pengeluaran_investasi_pembangunan_aset_tetap",
            // width: 150,
            align: "right",
            scopedSlots: {
              customRender: "pengeluaran_investasi_pembangunan_aset_tetap",
            },
          },
        ],
      },
      {
        title: "Total Pengeluaran",
        key: "total_pengeluaran",
        // width: 150,
        align: "right",
        scopedSlots: { customRender: "total_pengeluaran" },
      },
      {
        title: "Pendanaan",
        key: "pendanaan",
        // width: 150,
        align: "right",
        scopedSlots: { customRender: "pendanaan" },
      },
      {
        title: "Bunga Bank",
        key: "bunga_bank",
        // width: 150,
        align: "right",
        scopedSlots: { customRender: "bunga_bank" },
      },
      {
        title: "Create By",
        key: "create_by",
        // width: 150,
        align: "center",
        scopedSlots: { customRender: "create_by" },
      },
      {
        title: "Update By",
        key: "update_by",
        // width: 150,
        align: "center",
        scopedSlots: { customRender: "update_by" },
      },
      {
        title: "Action",
        width: 65,
        key: "action",
        align: "center",
        scopedSlots: { customRender: "action" },
      },
    ];

    return {
      show_modal: false,
      mode_modal: "Create",
      type_modal: "plus",
      year: [],
      loading: {
        page: false,
        table: false,
        submit: false,
      },
      selected: {
        year: "",
      },
      columns,
      data_table: [],
      yearOpen: false,
      show_create: false,
      sum_pengeluaran: 0,
      form: {
        pendapatan: 0,
        pengeluaran_beban_proyek: 0,
        pengeluaran_pengadaan_inventori: 0,
        pengeluaran_beban_admin_umum: 0,
        pengeluaran_beban_penjualan: 0,
        pengeluaran_investasi_pengadaan_aset: 0,
        pengeluaran_investasi_pengembangan_produk: 0,
        pengeluaran_investasi_pengembangan_pasar: 0,
        pengeluaran_kewajiban_hutang_cop: 0,
        pengeluaran_investasi_pengembangan_teknologi: 0,
        pengeluaran_investasi_pembangunan_aset_tetap: 0,
        pendanaan: 0,
        bunga_bank: 0,
      },
      id_cashflow: null,
    };
  },

  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatus",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
  },

  beforeCreate() {
    this.form_create = this.$form.createForm(this);
  },

  created() {
    //this.selected.year = new Date().getFullYear();
  },

  mounted() {
    this.fetchData();
    if (this.getAuth.nama_bidang[0] == "Financial Control")
      this.show_create = true;
  },

  methods: {
    moment,
    async fetchData() {
      this.loading.table = true;
      try {
        const response = await axios({
          method: "GET",
          url: this.$serviceUrl + "cashflow_planning",
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "X-API-KEY": this.getAuth.apikey,
          },
          params: {
            tahun: this.selected.year,
          },
        });
        this.data_table = response.data.data;
        this.year = response.data.tahun;
        this.loading.table = false;
      } catch (error) {
        console.log(error);
        this.loading.table = false;
      }
    },

    showModal(mode, item = {}) {
      this.show_modal = true;
      this.mode_modal = mode;
      this.type_modal = mode == "Create" ? "plus" : "edit";
      //this.selected_row = item;
      if (item) {
        this.form_create.resetFields();
        this.form = {
          year: item.year,
          pendapatan: item.pendapatan,
          pengeluaran_beban_proyek: item.pengeluaran_beban_proyek,
          pengeluaran_pengadaan_inventori: item.pengeluaran_pengadaan_inventori,
          pengeluaran_beban_admin_umum: item.pengeluaran_beban_admin_umum,
          pengeluaran_beban_penjualan: item.pengeluaran_beban_penjualan,
          pengeluaran_investasi_pengadaan_aset:
            item.pengeluaran_investasi_pengadaan_aset,
          pengeluaran_investasi_pengembangan_produk:
            item.pengeluaran_investasi_pengembangan_produk,
          pengeluaran_investasi_pengembangan_pasar:
            item.pengeluaran_investasi_pengembangan_pasar,
          pengeluaran_kewajiban_hutang_cop:
            item.pengeluaran_kewajiban_hutang_cop,
          pengeluaran_investasi_pengembangan_teknologi:
            item.pengeluaran_investasi_pengembangan_teknologi,
          pengeluaran_investasi_pembangunan_aset_tetap:
            item.pengeluaran_investasi_pembangunan_aset_tetap,
          pendanaan: item.pendanaan,
          bunga_bank: item.bunga_bank,
        };
        this.sum_pengeluaran = item.total_pengeluaran;
        this.id_cashflow = item.id_fc_cashflow_planning;
      }
    },

    modalOnClose() {
      this.show_modal = false;
      this.form_create.resetFields();
      this.sum_pengeluaran = 0;
    },

    changeYear() {
      this.fetchData();
    },

    handleOpenChange(status) {
      this.yearOpen = status;
    },

    handleYearChange(value) {
      this.form_create.setFieldsValue({
        year: value,
      });

      this.yearOpen = false;
    },

    handleKeyup() {
      let form = this.form_create.getFieldsValue();
      let sum =
        parseFloat(
          form.pengeluaran_beban_proyek ? form.pengeluaran_beban_proyek : 0
        ) +
        parseFloat(
          form.pengeluaran_pengadaan_inventori
            ? form.pengeluaran_pengadaan_inventori
            : 0
        ) +
        parseFloat(
          form.pengeluaran_beban_admin_umum
            ? form.pengeluaran_beban_admin_umum
            : 0
        ) +
        parseFloat(
          form.pengeluaran_beban_penjualan
            ? form.pengeluaran_beban_penjualan
            : 0
        ) +
        parseFloat(
          form.pengeluaran_investasi_pengadaan_aset
            ? form.pengeluaran_investasi_pengadaan_aset
            : 0
        ) +
        parseFloat(
          form.pengeluaran_investasi_pengembangan_produk
            ? form.pengeluaran_investasi_pengembangan_produk
            : 0
        ) +
        parseFloat(
          form.pengeluaran_investasi_pengembangan_pasar
            ? form.pengeluaran_investasi_pengembangan_pasar
            : 0
        ) +
        parseFloat(
          form.pengeluaran_kewajiban_hutang_cop
            ? form.pengeluaran_kewajiban_hutang_cop
            : 0
        ) +
        parseFloat(
          form.pengeluaran_investasi_pengembangan_teknologi
            ? form.pengeluaran_investasi_pengembangan_teknologi
            : 0
        ) +
        parseFloat(
          form.pengeluaran_investasi_pembangunan_aset_tetap
            ? form.pengeluaran_investasi_pembangunan_aset_tetap
            : 0
        );

      this.sum_pengeluaran = sum;
      //   this.form_create.setFieldsValue({
      //     total_pengeluaran: sum,
      //   });
    },

    onSubmit() {
      this.loading.submit = true;
      this.form_create.validateFields(async (err, values) => {
        if (err) {
          this.loading.submit = false;
          return;
        }
        try {
          const payload = {
            pendapatan: values.pendapatan,
            pengeluaran_beban_proyek: values.pengeluaran_beban_proyek,
            pengeluaran_pengadaan_inventori:
              values.pengeluaran_pengadaan_inventori,
            pengeluaran_beban_admin_umum: values.pengeluaran_beban_admin_umum,
            pengeluaran_beban_penjualan: values.pengeluaran_beban_penjualan,
            pengeluaran_investasi_pengadaan_aset:
              values.pengeluaran_investasi_pengadaan_aset,
            pengeluaran_investasi_pengembangan_produk:
              values.pengeluaran_investasi_pengembangan_produk,
            pengeluaran_investasi_pengembangan_pasar:
              values.pengeluaran_investasi_pengembangan_pasar,
            pengeluaran_kewajiban_hutang_cop:
              values.pengeluaran_kewajiban_hutang_cop,
            pengeluaran_investasi_pengembangan_teknologi:
              values.pengeluaran_investasi_pengembangan_teknologi,
            pengeluaran_investasi_pembangunan_aset_tetap:
              values.pengeluaran_investasi_pembangunan_aset_tetap,
            total_pengeluaran: this.sum_pengeluaran,
            pendanaan: values.pendanaan,
            bunga_bank: values.bunga_bank,
          };

          if (this.mode_modal == "Create") {
            payload.year = values.year.format("YYYY");
            await axios({
              method: "POST",
              url: this.$serviceUrl + "cashflow_planning",
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "X-API-KEY": this.getAuth.apikey,
              },
              data: payload,
            })
              .then((response) => {
                if (response.data.status) {
                  this.loading.submit = false;
                  this.displayMessage(response.data.message);
                  this.modalOnClose();
                  this.fetchData();
                } else {
                  this.$notification.error({
                    message: "Error Message!",
                    description: response.data.message,
                  });
                }
                this.loading.submit = false;
              })
              .catch((err) => {
                this.loading.submit = false;
                let response = Object.assign({}, err.response.data);
                console.log(response);
                if (response.message && response.status == false) {
                  this.$notification.warning({
                    message: "Warning Message!",
                    description: response.message,
                  });
                }
              });
          } else {
            payload.id_fc_cashflow_planning = this.id_cashflow;
            await axios({
              method: "PUT",
              url: this.$serviceUrl + "cashflow_planning",
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "X-API-KEY": this.getAuth.apikey,
              },
              data: payload,
            })
              .then((response) => {
                if (response.data.status) {
                  this.loading.submit = false;
                  this.displayMessage(response.data.message);
                  this.modalOnClose();
                  this.fetchData();
                } else {
                  this.$notification.error({
                    message: "Error Message!",
                    description: response.data.message,
                  });
                }
                this.loading.submit = false;
              })
              .catch((err) => {
                this.loading.submit = false;
                let response = Object.assign({}, err.response.data);
                console.log(response);
                if (response.message && response.status == false) {
                  this.$notification.warning({
                    message: "Warning Message!",
                    description: response.message,
                  });
                }
              });
          }
        } catch (error) {
          this.loading.submit = false;
          console.log(error);
          this.$notification.warning({
            message: "Warning Message!",
            description: error,
          });
          //this.modalOnClose();
        }
      });
    },
  },
};
</script>

<style lang="less">
.c_annualPlafon {
  .ant-card-head-title {
    margin-right: 0px !important;
  }
  .cmain-title {
    max-width: 50%;
    text-wrap: auto;
    word-break: normal;
  }
  .cbtn-create {
    i {
      color: #fff;
    }
    path {
      color: #fff;
    }
    span {
      color: #fff;
    }
  }
  .hdr_plfn {
    .ant-table-title {
      padding-bottom: 0px;
    }
  }
  .option_plfn {
    td {
      padding: 0px;
    }
  }
  .hdr_plfn_selection {
    padding: 16px;
    cursor: pointer;
  }
  .hdr_plfn_selection.isfocused {
    background-color: fade(@color-secondary, 5%);
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.25), 0 2px 8px rgba(0, 0, 0, 0.25),
      inset 0px 0px 0px 1px rgba(255, 255, 255, 0.1);
    border-left-style: solid;
    border-left-color: @color-secondary;
  }
  .row-ecv {
    .ant-input-number {
      justify-content: flex-end;
    }
    .ant-input-number-input {
      text-align: right;
      display: block;
    }
  }
  .row_h {
    margin-right: 11px;
  }

  .ngabango {
    background-color: fade(@color-primary, 35%);
  }
}

.cAnnualfromcreate {
  .ant-input-number-input {
    text-align: right;
    padding-right: 25px;
  }
}

.plafonformtables {
  // .ant-table-row {
  .ant-table-thead {
    background: #c1c1c1;
    font-weight: bolder;
  }
  tr:first-child {
    td:hover {
      background: #00ca8e;
    }
  }
  td:nth-child(4) {
    background: #c1c1c1;
  }

  .ant-table-thead
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY)
    > td,
  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY)
    > td,
  .ant-table-thead
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY)
    > td,
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected):not(.cSUMMARY)
    > td {
    background: none;
  }

  .ant-table-thead
    > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr.cSUMMARY.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-thead
    > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr.cSUMMARY:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: #c1c1c1;
  }
  // }
}

.overvalueRow {
  background-color: fade(@color-primary, 35%);
}

.custom-card .ant-card-body {
  padding: 0px !important;
}

.custom-table .ant-table {
  border: none !important;
}

.custom-table .ant-table-container {
  border-inline-start: none !important;
  border-top: none !important;
}

.custom-table .ant-table-bordered > .ant-table-container {
  border: none !important;
}

.single-parent {
  text-transform: uppercase;
  font-weight: bold;
}

.summary-row td {
  background: #f3e8e8 !important;
  font-weight: bold;
}

.chart-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.progress-big-text .ant-progress-text {
  font-size: 22px !important;
  font-weight: bold;
}

.footer-card {
  margin-top: 10px;
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
